"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const surface_1 = require("../../../../surface");
const workflowGroup_style_1 = __importDefault(require("./workflowGroup.style"));
const WorkflowGroup = ({ classes, name, avatar = null }) => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.groupLabel }, { children: [avatar && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.groupAvatar }, { children: jsx_runtime_1.jsx(surface_1.AvatarGroup, { src: avatar, size: 22 }, void 0) }), void 0)), name] }), void 0));
exports.WorkflowGroup = WorkflowGroup;
exports.default = react_jss_1.default(workflowGroup_style_1.default)(react_1.default.memo(exports.WorkflowGroup));
//# sourceMappingURL=index.js.map